/* globals document */

'use strict';

const runExperiment = eligibilityObj => {
  const { name } = eligibilityObj || {};

  if (!name) return false;

  let showHalfSheet = false;

  window.Finch.experiment(name, {
    Control() {},
    Treatment() {
      showHalfSheet = true;
    },
  });

  return showHalfSheet;
};

const getSubmitUrl = () => {
  const checkedOption = document.querySelector(
    '.m-option-b.inline-list input:checked'
  );
  let buyUrl;

  if (checkedOption) {
    buyUrl = checkedOption.value;
  }

  const buyButton = document.querySelector('.t-button.buy');

  if (buyButton && !buyUrl) {
    buyUrl = buyButton.getAttribute('href');
  }

  return buyUrl;
};

const updateUrlWithGuestParam = url =>
  url.includes('?') ? `${url}&guest=true` : `${url}?guest=true`;

const handleSigninAction = buyUrl => {
  window.location.href = buyUrl;
};

const handleGuestCheckoutAction = buyUrl => {
  window.location.href = updateUrlWithGuestParam(buyUrl);
};

const handleCartAction = (cartForm, updateAction = false) => {
  if (updateAction) {
    const { action } = cartForm;
    cartForm.action = updateUrlWithGuestParam(action);
  }

  cartForm.submit();
};

const triggerHalfSheet = (buyUrl, cartForm) => {
  const handleGuestClick = () => {
    const updateCartAction = true;

    if (cartForm) {
      handleCartAction(cartForm, updateCartAction);
    } else {
      handleGuestCheckoutAction(buyUrl);
    }
  };

  const handleSigninClick = () => {
    if (cartForm) {
      handleCartAction(cartForm);
    } else {
      handleSigninAction(buyUrl);
    }
  };

  const redirectUrl = updateUrlWithGuestParam(buyUrl);

  window.Groupon.LSApp.showGuestCheckoutHalfPage({
    redirectUrl,
    handleGuestClick,
    handleSigninClick,
  });
};

const handleGuestCheckout = (
  { buyUrl, ev, isCart, isGift, payloadData },
  callback
) => {
  const { guestCheckoutEligible } = payloadData || {};
  const addCartButtonClick = ev && ev.target && ev.target.id === 'add-to-cart';
  const showHalfSheet =
    !addCartButtonClick && runExperiment(guestCheckoutEligible);

  if (isCart && isGift) return;

  if (showHalfSheet) {
    const buyUrlStr =
      typeof buyUrl === 'function' ? buyUrl() : buyUrl || getSubmitUrl();
    const cartForm =
      isCart && !isGift && document.querySelector('#goods-add-to-cart-form');

    if (buyUrlStr || cartForm) {
      if (ev) {
        ev.preventDefault();
      }

      triggerHalfSheet(buyUrlStr, cartForm);
    }
  } else if (callback) {
    callback(showHalfSheet);
  }
};

module.exports = {
  handleGuestCheckout,
};
